import React from 'react';

const SectionList = ({ title, description, children }) => (
  <div className="flex flex-col gap-4">
    <div>
      <h3 className="pb-1 text-base font-500 text-neutral-900">{title}</h3>
      <p className="text-sm font-400 leading-[22px] text-neutral-700">{description}</p>
    </div>
    {children}
  </div>
);

export default SectionList;
